import { PatchAdjusterOtherDamagedDescriptionQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAdjusterOtherDamagedDescription/patchAdjusterOtherDamagedDescriptionQuery.type';
import { patchAdjusterOtherDamagedDescriptionFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAdjusterOtherDamagedDescription/patchAdjusterOtherDamagedDescriptionQueryFunction';

export const patchAdjusterOtherDamagedDescriptionQueryOptions = () => {
  return {
    mutationKey: ['postAdjusterOtherDamagedDescription'],
    mutationFn: (params: PatchAdjusterOtherDamagedDescriptionQueryParamsType) =>
      patchAdjusterOtherDamagedDescriptionFunction({ ...params }),
  };
};
